import { getModalOptions } from 'utils/navigationUtils';

export const modalFullScreenOptions = getModalOptions(undefined, true);

export const modalPartialScreenOptions = getModalOptions('70%', true);

export const licensePlatePermissionScreenOptionsForMobile = getModalOptions(
  '50%',
  true
);

export const licensePlatePermissionScreenOptionsForWeb = getModalOptions(
  '45%',
  true
);
